import { getConfig, useCoreImports } from '@b2ag/micro-front-tools'
import { isWebViewFarmi } from '@b2ag/farmi-app-appro-tools'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import type { RouteLocationNormalized } from 'vue-router'
import { getLocaleForI18n } from '@b2ag/utils/src/i18n-routing'

function getUrl(thePath: string, base: string | undefined = window.location.origin): URL {
  return new URL(thePath, base)
}

function getPageInfo(route: Record<string, any>) {
  let pageType: { name: string; category: string } | undefined
  if (route.meta && route.meta.analyticsPageInfo) {
    pageType = route.meta.analyticsPageInfo
  } else if (route.matched && route.matched.length > 0) {
    const matchedRoutes = route.matched.slice().reverse()
    const firstParentWithPageType = matchedRoutes.find(
      (matchedRoute: Record<string, any>) => matchedRoute.meta && matchedRoute.meta.analyticsPageInfo,
    )
    if (firstParentWithPageType) {
      pageType = firstParentWithPageType.meta.analyticsPageInfo
    }
  }

  return pageType
}

export function trackPageView(to: RouteLocationNormalized, from: RouteLocationNormalized, store: Record<string, any>) {
  const urlTo = getUrl(to.fullPath)
  const urlFrom = getUrl(from.fullPath, document.referrer || undefined)
  const pageInfo = getPageInfo(to)

  const payload = {
    user: store?.getters?.analyticsUserPayload,
    page: {
      path: to.path,
      domain_name: urlTo.hostname,
      url: urlTo.toString(),
      referrer_path: from.path,
      referrer_domain_name: urlFrom.hostname,
      referrer_url: urlFrom.toString(),
      page_name: pageInfo?.name ?? to.name,
      type: pageInfo?.category ?? to.name,
      page_category: pageInfo?.category ?? to.name,
      page_title: window.document.title,
      environment: getConfig('ENVIRONMENT_NAME'),
      is_web_view: isWebViewFarmi(useCoreImports().useRequestHeader('user-agent')),
      country: getLocaleForI18n(to.path),
      utm: {
        source: to.query?.utm_source,
        medium: to.query?.utm_medium,
        campaign: to.query?.utm_campaign,
      },
    },
  }
  useAnalyticService().trackEvent('page_view', payload)
}
